// 把下划线转成tuofeng
function underLineToCamel(str) {
    let arr = str.split('_');
    let _str = arr[0];
    arr.forEach((item, index) => {
        if (index > 0) {
            _str += item.substr(0, 1).toUpperCase() + item.substr(1);
        }
    });
    return _str;
}
export default underLineToCamel;
